import {useEffect, useMemo, useState} from 'react';

export function useMediaQuery(maxWidth, minWidth) {
    const query = useMemo(() => {
        if (minWidth && maxWidth) return `(min-width: ${minWidth}px) and (max-width: ${maxWidth}px)`;
        if (minWidth) return `(min-width: ${minWidth}px)`;
        return `(max-width: ${maxWidth ?? 1024}px)`;
    }, [maxWidth, minWidth]);

    const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

    useEffect(() => {
        const media = window.matchMedia(query);
        const listener = (e) => setMatches(e.matches);

        media.addEventListener("change", listener);
        return () => media.removeEventListener("change", listener);
    }, [query]);

    return matches;
}

export function withMediaQuery(WrappedComponent, queries = {}) {
    return function WithMediaQueryWrapper(props) {
        const mediaProps = Object.fromEntries(
            Object.entries(queries).map(([propName, { maxWidth, minWidth }]) => [
                propName,
                useMediaQuery(maxWidth, minWidth),
            ])
        );
        return <WrappedComponent {...props} {...mediaProps} />;
    };
}